import React, { Fragment, useEffect } from 'react';
import { UIStateProps, uiState } from '../../atoms/uiAtom';

import Header from './Header';
import { useRouteError } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import video from '../../assets/oops.mp4';

export interface RouteErrorBoundaryProps {
  hasHeader?: boolean;
}
export default function RouteErrorBoundary({ hasHeader }: RouteErrorBoundaryProps) {
  const { i18n } = useTranslation();
  const error = useRouteError() as Error;
  const setUiState = useSetRecoilState<UIStateProps>(uiState);

  useEffect(() => {
    localStorage.removeItem('user_preferences_state');
    if (error) {
      console.error(error.message);
    }
    setUiState((prev) => ({ ...prev, hasFatalError: true }));
  }, [error, setUiState]);

  return (
    <Fragment>
      {hasHeader && <Header />}
      <main className="container">
        <section className="error-boundary">
          <video autoPlay muted>
            <source src={video} />
          </video>
          <h1 className="text-center">{i18n.t('common.error.occur')}</h1>
          <p className="text-center">{i18n.t('common.error.support')}</p>
        </section>
      </main>
    </Fragment>
  );
}
